export const LOGIN_NAV_ITEMS = [
  { icon: 'login', label: 'Login', active: true },
  { icon: 'support_agent', label: 'Contact Admin', active: false },
]

export const LOGIN_COPY = {
  brand: 'Bridge',
  tagline: 'Architectural Anchor',
  title: 'Welcome Back.',
  subtitle:
    'Secure authentication for Bridge Architectural Systems and Project Management.',
  tenantUsernameLabel: 'Tenant Username',
  tenantUsernamePlaceholder: 'e.g. BOSS0001',
  identifierLabel: 'Official Email',
  identifierPlaceholder: 'e.g. name@bridge.arch',
  passwordLabel: 'Password',
  passwordPlaceholder: '........',
  forgotPassword: 'Forgot Password?',
  rememberDevice: 'Remember this device for 30 days',
  loginCta: 'Login',
  verificationTitle: 'Agent Verification',
  verificationSubtitle: 'Enter the verification code sent to your registered device.',
  verificationLabel: 'Verification Code',
  verificationPlaceholder: 'Enter verification code',
  verificationCta: 'Verify',
  requestAccessLabel: 'New to the structural grid?',
  requestAccessLink: 'Request Account Access',
  readinessLabel: 'System Readiness: 33%',
}

export const LOGIN_FOOTER_LINKS = [
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms of Service', href: '#' },
  { label: 'Security Whitepaper', href: '#' },
  { label: 'Help Center', href: '#' },
]

export const LOGIN_FLOATING_NOTICE = {
  icon: 'architecture',
  title: 'Structural Integrity Phase II',
  description:
    'System-wide updates to drafting protocols are now live. Please review the updated handbook.',
}
